/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
// template components
import HeroSection from '@nmx/template/dist/componentLibrary/modules/HeroSection';

export const HeroSectionStyled = styled(HeroSection)`
  ${({ theme }) => {
    const xxlargeUp = theme.xxlargeUp();
    const mediumUp = theme.mediumUp();
    const smallUp = theme.smallUp();

    let xPos = 'center';
    let yPos = 0;

    // horizontal adjustment
    if(mediumUp){
      xPos = '72%';
    }

    // vertical adjustment
    if(xxlargeUp){
      yPos = '15%';
    }else if(smallUp){
      yPos = '25%';
    }

    return css`
      #background-image-brokerage-accounts-services-hero {
        background-position-x: ${xPos};
        background-position-y: ${yPos};
      }
    `;
  }}
`;
